<template>
  <div>
    <div>
      <div class="info row gy-1 pt-3 info-edit" v-if="!renderEmployerInfo">
        <!-- user name -->
        <div>
          <div class="row  justify-content-between" >
            <span class="info-display info-name col-lg-6 col-md-6 col-sm-6 ps-2 ms-1 mb-2" v-if="employerInfo.name">
                  {{employerInfo.name}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="employerInfo.phone">
            <label><strong>Contact Number:</strong></label>
            <span> {{employerInfo.phone}} </span>
          </div>
          <div  class="col-12 mb-2" v-if="employerInfo.address1">
            <label><strong>Street Address 1:</strong></label>
            <span> {{employerInfo.address1}} </span>
          </div>
          <div class="col-12 mb-2" v-if="employerInfo.address2">
            <label><strong>Street Address2:</strong></label>
            <span> {{employerInfo.address2}} </span>
          </div>
          <div class="col-12 mb-2"  v-if="employerInfo.city">
            <label><strong>City:</strong></label>
            <span> {{employerInfo.city}} </span>
          </div>
          <div class="col-12 mb-2"  v-if="employerInfo.state">
            <label><strong>State:</strong></label>
            <span> {{employerInfo.state}} </span>
          </div>
          <div class="col-12 mb-2"  v-if="employerInfo.zip">
            <label><strong>Zip/Pin Code: </strong></label>
            <span> {{employerInfo.zip}} </span>
          </div>
          <div class="col-12 mb-2"  v-if="employerInfo.average_work_week">
            <label><strong>Average Work Week:</strong></label>
            <span> {{employerInfo.average_work_week}} </span>
          </div>
          <div class="col-12 mb-2"  v-if="employerInfo.employment_start_date">
            <label><strong>Employment Start Date:</strong></label>
            <span> {{employerInfo.employment_start_date}} </span>
          </div>
          <div class="col-12 mb-2"  v-if="employerInfo.occupation">
            <label><strong>Occupation:</strong></label>
            <span> {{employerInfo.occupation}} </span>
          </div>
          <div class="col-12 mb-2"  v-if="employerInfo.compensation_type">
            <label><strong>Compensation Type: </strong></label>
            <span v-if="employerInfo.compensation_type == 'G10L20'"> Greater than $10/hr but less than $20/hr</span>
            <span v-if="employerInfo.compensation_type == 'MW'">
                                  Minimum wage
                                </span>
            <span v-if="employerInfo.compensation_type == 'GMWL10'">
                                  Greater than minimum wage but less than $10/hr
                                </span>
            <span v-if="employerInfo.compensation_type == 'G20'">
                                  Greater than $20/hr
                                </span>
            <span v-if="employerInfo.compensation_type == 'Salary'">
                                  Salary
                                </span>
            <span v-if="employerInfo.compensation_type == '1099'" >
                                1099
                    </span>
          </div>
          <div class="col-12 mb-2"  v-if="employerInfo.employment_status">
            <label><strong>Employment Status: </strong></label>
            <span  v-if="employerInfo.employment_status == 'A'"> ACTIVE </span>
            <span v-if="employerInfo.employment_status == 'C'"> COBRA </span>
          </div>
          <div class="col-12 mb-2"  v-if="employerInfo.emp_industry">
            <label><strong>Employer Industry:</strong></label>
            <span> {{employerInfo.emp_industry}} </span>
          </div>
        </div>
        <div class="">
          <button @click="renderEmployerInfo = true"
                  class="btn btn-personal-info-edit btn-outline-info info-edit-btn w-100"
          >
            <i class="fas fa-pen me-2"></i>
            Edit Details
          </button>
        </div>
      </div>
      <div v-if="renderEmployerInfo">
        <employer-information :isRedirectionFromReview="true"
                              @cancelEditInfo="cancelEditInfo"
                              @updatedEditInfo="updatedEditInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import EmployerInformation from "../EmployerInformation";
export default {
  name: "EmployerInfoEdit",
  props: {
    employerInfo: {
      type: Object
    }
  },
  data () {
    return {
      renderEmployerInfo: false
    }
  },
  components: {
    EmployerInformation
  },
  methods: {
    cancelEditInfo () {
      let app = this
      app.renderEmployerInfo = false
    },
    updatedEditInfo () {
      let app = this
      app.renderEmployerInfo = false
      app.$emit('updatedEditInfo')
    }
  }
}
</script>
<style src="@/assets/css/review_edit.css"></style>
<style scoped>

</style>